import React from 'react';
import { TextField } from '@material-ui/core';

const InputField = ({ ...props }) => {
  return <TextField margin="dense" variant="outlined" fullWidth {...props} />;
};

export default InputField;
